import React, {useEffect, useState} from 'react';
import {Modal, Button, Input, message, Form} from 'antd';
import {PasswordControllerApi, PasswordDto} from '../../api';
import {useKeycloakHeader} from "../../config/Config";

const PasswordCreationModal = ({visible, onClose, onPasswordCreated, passwordToEdit}) => {
    const [form] = Form.useForm();
    const [editPassword, setEditPassword] = useState<PasswordDto | null>(null);

    const headers = useKeycloakHeader();
    const passwordControllerApi = new PasswordControllerApi();

    useEffect(() => {
        setEditPassword(passwordToEdit);
        if (passwordToEdit) {
            form.setFieldsValue({
                name: passwordToEdit.name,
                description: passwordToEdit.description
            })
        }
    }, [passwordToEdit])

    const handleClose = () => {
        onClose(true);
        setEditPassword(null);
        form.resetFields();
    }

    const handleSubmit = () => {
        form.validateFields().then(values => {
            const passwordDto: PasswordDto = {
                name: values.name,
                password: values.password,
                description: values.description
            }

            if (!editPassword) {
                passwordControllerApi.addNewPassword(passwordDto, headers)
                    .then(response => {
                        message.success('Passwort wurde erfolgreich angelegt');
                        onPasswordCreated(true);
                        onClose(true);
                        form.resetFields();
                    })
                    .catch(error => {
                        message.error({
                            content: 'Fehler beim Anlegen des Passworts: ' + error.message,
                            duration: 15
                        });
                    });
            } else {
                passwordDto.id = editPassword.id;
                passwordControllerApi.updatePassword(passwordDto, headers)
                    .then(response => {
                        message.success('Passwort wurde erfolgreich aktualisiert');
                        onPasswordCreated(true);
                        onClose(true);
                        form.resetFields();
                    })
                    .catch(error => {
                        message.error({
                            content: 'Fehler beim Aktualisieren des Passworts: ' + error.message,
                            duration: 15
                        });
                    });
            }


        }).catch(error => {
            message.error("Bitte die geforderten Felder ausfüllen!");
        });
    };

    return (
        <>
            <Modal
                title="Passwort erstellen"
                open={visible}
                onCancel={handleClose}
                footer={[
                    <Button key="cancel" onClick={handleClose}>
                        Abbrechen
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleSubmit}>
                        Speichern
                    </Button>
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{required: true, message: 'Bitte einen Namen eingeben'}]}
                    >
                        <Input placeholder="Name"/>
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Passwort"
                        rules={[{required: true, message: 'Bitte ein Passwort eingeben'}]}
                    >
                        <Input.Password placeholder="Passwort"/>
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Beschreibung"
                        rules={[{required: true, message: 'Bitte eine Beschreibung eingeben'}]}
                    >
                        <Input placeholder="Beschreibung"/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default PasswordCreationModal;
